import DOMPurify from 'dompurify'

// Mirrors the tag allow-list the news worker already applies in sanitizeInlineHtml,
// plus the block wrappers the article renderer emits itself.
const ALLOWED_TAGS = [
  'a', 'img', 'br', 'p',
  'table', 'thead', 'tbody', 'tr', 'th', 'td',
  'ul', 'ol', 'li',
  'strong', 'b', 'em', 'i', 'code', 'span', 'sup', 'sub', 'del', 'ins', 'mark',
]
const ALLOWED_ATTR = ['href', 'src', 'alt', 'class', 'loading', 'target', 'rel']
const ALLOWED_URI_REGEXP = /^https?:\/\//i

// Article HTML is parsed from third-party pages and is re-decoded on the client
// (decodeEscapedArticleHtml), so it must be sanitized again right before v-html.
export function sanitizeArticleHtml(value = '') {
  const source = String(value || '')
  if (!source) return ''
  if (typeof window === 'undefined') return source

  return DOMPurify.sanitize(source, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP,
    ALLOW_DATA_ATTR: false,
    ALLOW_ARIA_ATTR: false,
  })
}

export function articleTextFromHtml(value = '') {
  const source = String(value || '')
  if (!source || typeof DOMParser === 'undefined') return source

  const spaced = source
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<\/(p|div|li|ul|ol|section|article|blockquote|h[1-6])>/gi, ' ')

  // DOMParser builds an inert document, so image/media loaders never run.
  return new DOMParser().parseFromString(spaced, 'text/html').body.textContent || ''
}
